export function latlngDistance(lat1,lon1,lat2,lon2, unitOfDistance?:number)
{
    // The math module contains a function
    // named toRadians which converts from
    // degrees to radians.
    lon1 = lon1 * Math.PI / 180;
    lon2 = lon2 * Math.PI / 180;
    lat1 = lat1 * Math.PI / 180;
    lat2 = lat2 * Math.PI / 180;

    // Haversine formula
    let dlon = lon2 - lon1;
    let dlat = lat2 - lat1;
    let a = Math.pow(Math.sin(dlat / 2), 2)
        + Math.cos(lat1) * Math.cos(lat2)
        * Math.pow(Math.sin(dlon / 2), 2);

    let c = 2 * Math.asin(Math.sqrt(a));

    // Radius of earth in meters
    let r = 6371 * 1000;

    // calculate the result in meters
    let result = (c * r);
    
    // convert to miles and kilometers
    let resultInMiles = (result / 1609).toFixed(2);
    let resultInKm = (result / 1000).toFixed(2);

    // return based on unit preference
    if(unitOfDistance){
        if(unitOfDistance === 2) {
            return `${resultInKm} Kilometers`;
        } else {
            return `${resultInMiles} Miles`;
        }
    }else{
        return resultInMiles;
    }
}
